import React, { useState, useEffect } from "react";
import HeaderBar from "../../../components/header/headerBar";
import { TextBox, Textarea } from "../../../components/textfield";
import { Table, TableColumn } from "../../../components/table";
import MainButton from "../../../components/button/mainButton";
import { AlertOutlined } from '@ant-design/icons';
import { mdiPrinter, mdiCheckCircleOutline, mdiAlertOctagram, mdiAlertOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { numberWithCommas } from "../../../helpers/functions";
import {
  InputNumber,
  Modal,
  Spin,
  notification
} from "antd";
import EmptyModel from "../../../components/modal/emptyModal";
import Input from "../../../components/textfield/input";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
interface Props {
  title1: string;
  title2: string;
  backgroundColor?: string;
}

interface ParamTypes {
  id: string;
  payment: string;
  approval: string;
}

const HistoryDetail = () => {
  const { confirm } = Modal;
  const history = useHistory();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const { isFetchedUser, socket } = useSelector((state: any) => state);
  const [dataSO, setDataSO] = useState<any>({});
  const [paymentRecord, setPaymentRecord] = useState<any>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isWaitingDiscount, setIsWaitingDiscount] = useState<boolean>(false);
  const [confirmDiscountText, setConfirmDiscountText] = useState<string>("");
  const [isMode, setIsMode] = useState<string | null>("");
  const columns = [
    {
      title: "",
      align: "",
    },
    {
      title: "รายการ/List",
      align: "center",
    },
    {
      title: "ราคา/หน่วย/Price/Unit",
      align: "center",
    },
    {
      title: "จำนวน/Quantity",
      align: "center",
    },
    {
      title: "หน่วย/Unit",
      align: "center",
    },
    {
      title: "ฟรี/Free",
      align: "center",
    },
    {
      title: "ส่วนลดพิเศษ/Special Discount",
      align: "center",
    },
    {
      title: "ราคาพิเศษ/Special Price",
      align: "center",
    },
    {
      title: "ส่วนลด/Discount(Baht,%)",
      align: "center",
    },
    {
      title: "ราคารวม/Total Price",
      align: "center",
    },
    {
      title: "หมายเหตุ/Remark",
      align: "center",
    },
  ];
  const columnsPro = [
    {
      title: "",
      align: "",
    },
    {
      title: "รายการ/List",
      align: "center",
    },
    {
      title: "ราคา/หน่วย/Price/Unit",
      align: "center",
    },
    {
      title: "จำนวน/Quantity",
      align: "center",
    },
    {
      title: "หน่วย/Unit",
      align: "center",
    },
    {
      title: "ฟรี/Free",
      align: "center",
    },
    {
      title: "ส่วนลด/Discount(Baht,%)",
      align: "center",
    },
    {
      title: "ราคารวม/Total Price",
      align: "center",
    },
    {
      title: "หมายเหตุ/Remark",
      align: "center",
    },
  ];

  const columnsPayment = [
    {
      title: "ประเภทการชำระ/Payment Type",
      align: "",
    },
    {
      title: "ชื่อการชำระ/Payment Name",
      align: "center",
    },
    {
      title: "จำนวน/Amount",
      align: "center",
    },
    {
      title: "วันที่ชำระ/Payment Date",
      align: "center",
    },
    {
      title: "เลขบัตร/Card Number",
      align: "center",
    },
    {
      title: "ประเภทบัตร/Card Type",
      align: "center",
    },
    {
      title: "จ่ายเข้า/Pay In",
      align: "center",
    },
    {
      title: "รายละเอียด/Payment Details",
      align: "center",
    }
  ];
  const { id, payment, approval } = useParams<ParamTypes>();

  useEffect(() => {
    console.log(search)
    getSO();
    axios.get(`/payments/record?id=${payment}`).then((res) => {
      setPaymentRecord(res?.data)
    });
  }, [id, approval]);

  useEffect(() => {
    setIsMode(query.get("mode"))
    console.log(isMode)
    if (query.get("mode") === "approval")
      setIsWaitingDiscount(false)
  }, [search]);


  useEffect(() => {
    if (isFetchedUser && !socket.loadingCashier && isMode !== "approval")
      setTimeout(() => {
        dispatch({
          type: "SET_SOCKET",
          data: {
            ...socket,
            loadingCashier: true
          },
        });
        socket.io?.on("cashierEvent", (req: any) => {
          setIsWaitingDiscount(false)
          notification.open({
            message: 'Notification',
            description: req.message,
            duration: 0,
            icon: <AlertOutlined style={{ color: '#e76464' }} />,
          });
          getSO()
        });
        console.log(socket.io)
      }, 1500);
  }, [isFetchedUser, socket]);

  const getSO = () => {
    axios.get(`/so/get-so?soId=${id}`).then((res) => {
      setDataSO(res?.data);
      let { status } = res?.data;
      if (status === "waiting_discount_approve" && query.get("mode") !== "approval") {
        setIsWaitingDiscount(true)
      }
    });
  }

  const onConfirmDiscountText = (index: number, val: string) => {
    let data: any = dataSO?.items;
    data[index]["discount"] = val;

    let pattern = /%/;
    let result = pattern.test(val);
    if (result) {
      let reDiscount = val.replace("%", "");
      console.log("Percent", parseInt(reDiscount))
      data[index]["discountPercent"] = parseInt(reDiscount)
    } else {
      let percent = (((parseInt(val) || 0) / data[index]?.totalPrice) * 100) || 0
      console.log("Percent", percent)
      data[index]["discountPercent"] = percent
    }

    setDataSO({ ...dataSO, items: data });
  }

  useEffect(() => {
    console.log(confirmDiscountText)
  }, [confirmDiscountText]);


  const calculateDiscount = (discount: string, total: number) => {
    let pattern = /%/;
    let result = pattern.test(discount);
    if (result) {
      let reDiscount = discount.replace("%", "");
      return total - ((total * parseInt(reDiscount)) / 100)
    }
    console.log(((parseInt(discount) / total) * 100) + "%")
    return total - (parseInt(discount) || 0);
  }

  const displayDiscount = (discount: string) => {
    let pattern = /%/;
    let result = pattern.test(discount);
    if (result) {
      return discount
    }
    return (parseInt(discount) || "") == "" ? "" : numberWithCommas(parseInt(discount), 2);
  }

  const totalPrice = dataSO?.items?.reduce((total: number, item: any) => total + item?.totalPrice, 0);
  const totalPriceDiscount = dataSO?.items?.reduce((total: number, item: any) => total + (item?.totalPrice * (item?.discountPercent) / 100), 0);


  const totalDiscount = dataSO?.items?.reduce((total: number, item: any) => {
    return total + (((item?.price * item?.quantity) - item?.specialPrice) * ((item?.discountPercent) / 100))
  }, 0);

  return (
    <div>
      <HeaderBar title={`CASHIER/Payment History/${dataSO?.code}`} btnBack />
      <EmptyModel show={isWaitingDiscount} btnClose={false} width="650px">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >

          <div className="row justify-center">
            <Icon path={mdiAlertOutline} color="#E76464" size="120" />
          </div>

          <div className="row justify-center  mt-20">
            <div
              style={{
                padding: 0,
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 500,
                textAlign: "center"
              }}
            >
              ส่วนลดเกินกำหนด ต้องรอการอนุมัติ/Overdue Discount Awaiting Approval
            </div>
          </div>
        </div>
      </EmptyModel >
      <EmptyModel show={isOpen} btnClose={false} width="650px">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >

          <div className="row justify-center">
            <Icon path={mdiCheckCircleOutline} color="#86CFC6" size="120" />
          </div>

          <div className="row justify-center  mt-20">
            <div
              style={{
                padding: 0,
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 500,
                textAlign: "center"
              }}
            >
              บันทึกรายการเรียบร้อยแล้ว/List Saved Successfully.
            </div>
          </div>
        </div>
      </EmptyModel >
      <div className="page-container" style={{ padding: "20px 80px" }}>
        <div className="card-view" style={{ padding: "20px 40px" }}>
          <div className="row">
            <TextBox className="col-3" title="รหัสลูกค้า/CN" value={dataSO?.customerCode} />
            <TextBox className="col-3" title="รหัสการขาย/SO" value={dataSO?.code} />
            <TextBox className="col-3" title="เลขที่ใบยา/Ref.VN" value={dataSO?.vn} />
            <TextBox className="col-3" title="ชื่อลูกค้า/CUSTOMER NAME" value={`${dataSO?.customer}`} />
          </div>
        </div>

        <div style={{ marginTop: "20px" }}>
          <h5>รายการซื้อ/Purchase List</h5>
          <Table header={dataSO?.purchaseType === "promotion" ? columnsPro : columns}>
            {dataSO?.items?.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="5%">{index + 1}</TableColumn>
                <TableColumn width="20%">{item?.name}</TableColumn>
                <TableColumn width="10%" align="center">
                  {numberWithCommas(item?.price, 2)}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  {item?.quantity}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  {item?.number}
                </TableColumn>
                <TableColumn width="10%" align="left">
                  {item?.free?.productFree?.name}
                </TableColumn>
                {
                  dataSO?.purchaseType !== "promotion" &&
                  <TableColumn width="10%" align="right">
                    {numberWithCommas(item?.specialPrice, 2)}
                  </TableColumn>
                }
                {
                  dataSO?.purchaseType !== "promotion" &&
                  <TableColumn width="10%" align="right">
                    {numberWithCommas(item?.specialDiscount, 2)}
                  </TableColumn>
                }

                <TableColumn width="10%" align="center"
                >
                  <div style={{ color: item?.discountPercent >= item?.maximumDiscount ? "red" : "#000000" }}>{displayDiscount(item?.discount)}</div>
                </TableColumn>
                <TableColumn width="10%" align="right">
                  {numberWithCommas(calculateDiscount(item?.discount, item?.totalPrice), 2)}
                </TableColumn>
                <TableColumn width="10%" align="right">
                  {item?.remark}
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
        <div className="row">
          <div className="col-6">
            <table width="100%" style={{ fontSize: "14px" }}>
              <tr
                style={{
                  height: "50px",
                }}
              >
                <td
                  style={{
                    borderRight: "0px solid #aaa",
                    padding: "0px 0px",
                  }}
                >
                  <Textarea
                    placeholder="หมายเหตุ/Note"
                    value={dataSO?.note}
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <br />
                </td>
              </tr>
              <tr
                style={{
                  height: "50px",
                }}
              >
                <td
                  style={{
                    borderRight: "0px solid #aaa",
                    padding: "0px 0px",
                  }}
                >
                  <Textarea
                    placeholder="ที่อยู่ออกบิล/Billing Address"
                    value={dataSO?.billingAddress}
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <br />
                </td>
              </tr>
            </table>
          </div>
          <div className="col-6" style={{ padding: "10px" }}>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                    }}
                  >
                    โอนคอร์ส/Filler (Juvederm Vollift)
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                    }}
                  >
                    <b>0</b>
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                    }}
                  >
                    ยอดเงินส่วนลด/Discount amount.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                    }}
                  >
                    <b>{numberWithCommas(totalPriceDiscount, 2)}</b>
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#E76464",
                      color: "#fff",
                    }}
                  >
                    ยอดเงินหลังหักส่วนลดทั้งหมด/<br />
                    Balance after all discounts.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      color: "#fff",
                      background: "#E76464",
                    }}
                  >
                    <b>
                      {
                        numberWithCommas(totalPrice - totalPriceDiscount, 2)
                      }
                    </b>
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#fff",
                      color: "#000",
                    }}
                  >
                    ยอดเงินมัดจำ/Deposit amount.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      color: "#000",
                      background: "#fff",
                    }}
                  >
                    <b>{numberWithCommas(dataSO?.depositAmount, 2)}</b>
                  </td>
                </tr>
              </table>
            </div>
            <div style={{ padding: "0px 20px" }}>
              <table width="100%" style={{ fontSize: "14px" }}>
                <tr
                  style={{
                    backgroundColor: "#fff",
                    height: "50px",
                  }}
                >
                  <td
                    style={{
                      borderRight: "0px solid #aaa",
                      padding: "0px 10px",
                      background: "#D3D8DD",
                      color: "#000",
                    }}
                  >
                    ยอดเงินรวมที่ต้องชำระ/Total amount paid.
                  </td>
                  <td
                    align="right"
                    style={{
                      borderLeft: "0px solid #aaa",
                      padding: "0px 10px",
                      color: "#000",
                      background: "#D3D8DD",
                    }}
                  >
                    <b>
                      {
                        numberWithCommas( 
                          totalPrice -
                          totalPriceDiscount -
                          dataSO?.depositAmount -
                          dataSO?.paidAmount, 2)
                      }
                    </b>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <h5>ประวัติการชำระเงิน/Payment History</h5>
          <Table header={columnsPayment}>
            {paymentRecord?.paymentList?.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="5%">{item?.paymentType?.name}</TableColumn>
                <TableColumn width="20%">{item?.paymentName?.name}</TableColumn>
                <TableColumn width="10%" align="center">
                  {numberWithCommas(parseInt(item?.paymentAmount), 2)}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  {
                    moment(item?.paymentDate).format("DD-MM-YYYY")
                  }
                </TableColumn>
                <TableColumn width="5%" align="center">
                  {item?.bankNumber}
                </TableColumn>
                <TableColumn width="10%" align="right">
                  {item?.paymentName?.name}
                </TableColumn>
                <TableColumn width="10%" align="right">
                  {item?.paymentPayIN?.name}
                </TableColumn>
                <TableColumn width="10%" align="right">
                  {item?.paymentDetail}

                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div >
  );
};
export default HistoryDetail;
